import { Box, Stack } from "@mui/system";

import { spacing } from "../../../../../../../../../../assets/styles/tokens";
import ProblematicFtdsCard from "./ProblematicFtdsCard";

// ─── Static demo data (replaces sortedData from API) ─────────────────────────
const staticData = [
  {
    website_name: "Bettom Sport UK",
    website_id: "2319",
    ftd: 1,
    brand_action_date: "21/04/26",
  },
  {
    website_name: "Bettom Sport UK",
    website_id: "2319",
    ftd: 3,
    brand_action_date: "21/04/26",
  },
];
// ─────────────────────────────────────────────────────────────────────────────

const ProblematicFtdsItem = ({
  sortedData = staticData,
}: {
  sortedData?: any[];
}) => {
  return (
    <>
      <Box sx={{ mt: "-" + spacing.Spacing.md.$value }}>
        <Stack spacing={2}>
          {sortedData?.map((item: any, index: number) => (
            <ProblematicFtdsCard
              key={index}
              website_name={item.website_name}
              website_id={item.website_id}
              ftd={item.ftd}
              brand_action_date={item.brand_action_date}
            />
          ))}
        </Stack>
      </Box>
    </>
  );
};

export default ProblematicFtdsItem;
